import { FC, PropsWithChildren, useContext, useState } from "react";
import NotificationDispatch, { showErrorNotification } from "../../../../context/notificationContext";
import useI18n from "../../../../hooks/useTranslations";
import { useSteelVersionsApi } from "../../../../http/useSteelVersions";
import ModalDialog from "../../../ui/ModalDialog";

type DeleteSteelVersionDialogProps = PropsWithChildren<{
  onClose: () => void;
  itemIdToDelete: string;
  isOpen?: boolean;
}>;

const DeleteSteelVersionDialog: FC<DeleteSteelVersionDialogProps> = ({ children, onClose, isOpen, itemIdToDelete }) => {
  const i18n = useI18n();
  const dispatch = useContext(NotificationDispatch);
  const steelVersionsApi = useSteelVersionsApi();
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <>
      {!!isOpen && (
        <ModalDialog
          onClose={onClose}
          title={i18n.translation.steelVersions.delete}
          isSubmitting={isSubmitting}
          actions={[
            {
              title: i18n.translation.common.cancel,
              onClick: onClose,
              type: "secondary",
            },
            {
              title: i18n.translation.common.yes,
              onClick: () => {
                setIsSubmitting(true);
                steelVersionsApi
                  .deleteAdminSteelVersion(itemIdToDelete)
                  .then(onClose)
                  .catch((err) => dispatch(showErrorNotification(i18n, err)))
                  .finally(() => setIsSubmitting(false));
              },
            },
          ]}
        >
          {children}
        </ModalDialog>
      )}
    </>
  );
};

export default DeleteSteelVersionDialog;
